import { useFormik } from "formik";
import React from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setCompanyMessage } from "redux/actions";


import { useAppDispatch } from "redux/store";
import { addCompany, updateCompany } from "services/CompanyService";
import { Constant } from "template/Constant";
import * as yup from 'yup';
type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const CompanyForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const dispatch = useAppDispatch();
    const iValue = { company_id: 0, company_name: '', contact_person: '', contact_phone: '', regular_price: 0, email: '' };
    const initialValue = action === 'edit' ? row : iValue;


    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values) => {
            if (action === 'edit') {
                const response = await updateCompany(values.company_id, values);
                if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setCompanyMessage("Updated Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setCompanyMessage("Some error occured!"));
                }
            } else if (action === 'add') {
                const response = await addCompany(values);
                if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setCompanyMessage("Added Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setCompanyMessage("Some error occured!"));
                }
            }
        },
        validationSchema: yup.object({
            company_name: yup.string().required('company_name is required'),
            contact_person: yup.string().nullable(),
            contact_phone: yup.string().nullable(),
            regular_price: yup.number().nullable(),
            email: yup.string().nullable(),

        }),
    });
    return (
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold text-primary text-capitalize">{action} Company
                    <Button className="btn-icon-split float-right" onClick={() => hideShowForm(false)}>
                        <span className="icon text-white-50">
                            <i className="fas fa-list"></i>
                        </span>
                        <span className="text">View Company</span>
                    </Button>
                </h6>

            </Card.Header>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit} style={{textAlign:'right'}}>
                    <Form.Group>
                        <label className="form -control-label">company_name</label>
                        <Form.Control type="text" name="company_name" className="form-control" value={formik.values.company_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.company_name && !!formik.errors.company_name}
                            isValid={!!formik.touched.company_name && !formik.errors.company_name}
                        ></Form.Control>
                        {
                            formik.errors.company_name && (
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.company_name}
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label">contact_person</label>
                        <Form.Control type="text" name="contact_person" className="form-control" value={formik.values.contact_person}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.contact_person && !!formik.errors.contact_person}
                            isValid={!!formik.touched.contact_person && !formik.errors.contact_person}
                        ></Form.Control>
                        {
                            formik.errors.contact_person && (
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.contact_person}
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label">contact_phone</label>
                        <Form.Control type="text" name="contact_phone" className="form-control" value={formik.values.contact_phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.contact_phone && !!formik.errors.contact_phone}
                            isValid={!!formik.touched.contact_phone && !formik.errors.contact_phone}
                        ></Form.Control>
                        {
                            formik.errors.contact_phone && (
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.contact_phone}
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label">regular_price</label>
                        <Form.Control type="number" name="regular_price" className="form-control" value={formik.values.regular_price}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.regular_price && !!formik.errors.regular_price}
                            isValid={!!formik.touched.regular_price && !formik.errors.regular_price}
                        ></Form.Control>
                        {
                            formik.errors.regular_price && (
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.regular_price}
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label">email</label>
                        <Form.Control type="text" name="email" className="form-control" value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.email && !!formik.errors.email}
                            isValid={!!formik.touched.email && !formik.errors.email}
                        ></Form.Control>
                        {
                            formik.errors.email && (
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.email}
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>

                    <Form.Group>
                        <Button type="submit" className="float-right" variant="primary">שמור</Button>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    );
}

